import React from 'react';
import { Alert } from 'antd';

const BiddingTypeAlert = ({ biddingType }) => {
    return (
        <Alert
            message="Bidding Type Information"
            description={
                <div>
                    {biddingType ? (
                        <>
                            <p><strong>Sequential Bidding Selected</strong></p>
                            <p>In sequential bidding:</p>
                            <ul>
                                <li>Lots are auctioned one after another in a specific order</li>
                                <li>Each lot has its own dedicated time slot</li>
                                <li>Bidders can only bid on the current active lot</li>
                                <li>Similar to traditional live auctions</li>
                                <li>Better for maintaining focus on each individual lot</li>
                            </ul>
                        </>
                    ) : (
                        <>
                            <p><strong>Simultaneous Bidding Selected</strong></p>
                            <p>In simultaneous bidding:</p>
                            <ul>
                                <li>All lots are open for bidding at the same time</li>
                                <li>Bidders can place bids on any lot throughout the auction period</li>
                                <li>More flexible for bidders who want to participate in multiple lots</li>
                                <li>Better for shorter auction periods</li>
                                <li>Allows bidders to manage their bids across multiple lots</li>
                            </ul>
                        </>
                    )}
                </div>
            }
            type="info"
            showIcon
            style={{ marginBottom: '24px' }}
        />
    );
};

export default BiddingTypeAlert; 